import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-primary-600">
        <i className="ri-film-line text-[30px]"></i>
      </span>
      <p className="mt-6 font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-foreground-400">
        404 Not Found
      </p>
      <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950">这个页面走丢了</h1>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的路径 <span className="font-label text-foreground-800">{location.pathname}</span> 不存在，
        可能是链接有误或内容已调整。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/movies"
          className="cursor-pointer rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}